// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test'
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeAutoCompleteResizeMenu = function() {};

	// Fix conflict with theme's cart
	jQ(Selector.otpTopCartLink).on('click', function() {
		if(jQ('.boost-pfs-minicart-wrapper').length > 0) {
			jQ('#ajaxifyModal').hide();
			jQ('#ajaxifyCart-overlay').hide();
		}
	})
    

})();
	